import { render } from "./BaseSlider.vue?vue&type=template&id=2ffff46b&ts=true"
import script from "./BaseSlider.vue?vue&type=script&lang=ts"
export * from "./BaseSlider.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__